export default "__VITE_ASSET__c6Ow_4IO__"